module.exports = __webpack_public_path__ + "assets/img/ic-popup-gift.7bcccae0.svg";